import { useRef, useState, useLayoutEffect } from "react";

export default function useIsTruncated(deps = []) {
  const ref = useRef(null);
  const [isTruncated, setIsTruncated] = useState(false);

  useLayoutEffect(() => {
    const element = ref.current;
    if (!element) return;
    console.log(element.scrollHeight, element.offsetHeight);
    setIsTruncated(element.scrollHeight > element.offsetHeight + 1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);

  return [ref, isTruncated];
}
